import { React, useEffect, useState } from 'react';
import { getTeamAutocomplete } from 'api/FilterMapApi';
import { SelectComponent } from 'component/Select';

export const TeamFilter = (props) => {
  const [options, setOptions] = useState([]);

  const getTeamOptions = () => {
    getTeamAutocomplete()
      .then((res) => {
        const resOptions = res.data.map((item) => ({
          value: item,
          label: item,
        }));

        setOptions(resOptions);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getTeamOptions();
  }, []);

  return (
    <div className="flex-column-group">
      <span>Sort by team</span>
      <SelectComponent
        className="full"
        value={props.teamFilter}
        options={options}
        handleSelect={props.setTeamFilter}
        isMulti
      />
    </div>
  );
};
